import React from "react";
import { cn } from "@/helpers/utils";
import { CartEmptyIcon } from "@/components/icons/CartEmptyIcon";
import { CartFilledIcon } from "@/components/icons/CartFilledIcon";
import { Badge } from "@/components/Badge";

export type CartIconProps = {
  count: number;
  onClick: () => void;
  className?: string;
};

export const CartIcon = ({ count, onClick, className }: CartIconProps) => (
  <button
    className={cn(
      "group flex cursor-pointer items-center rounded-sm border-0 bg-transparent p-3 transition hover:bg-primary/10",
      className
    )}
    onClick={onClick}
  >
    <span className="sr-only">Open cart with {count} items</span>
    {count == 0 ? (
      <CartEmptyIcon className="stroke-primary text-primary group-hover:stroke-primary-900 group-hover:text-primary-900" />
    ) : (
      <div className="relative">
        <CartFilledIcon className="stroke-primary text-primary group-hover:stroke-primary-900 group-hover:text-primary-900" />
        <div
          aria-hidden="true"
          className="absolute -right-2.5 -top-2 flex h-5 w-5 items-center justify-center rounded-full bg-secondary-700 p-1 text-xs font-bold leading-none text-white transition group-hover:bg-secondary-800"
        >
          {count > 99 ? "99+" : count}
        </div>
      </div>
    )}
  </button>
);
